import { render, staticRenderFns } from "./TrustCustomerNotFound.vue?vue&type=template&id=2fabd9b0&scoped=true"
import script from "./TrustCustomerNotFound.vue?vue&type=script&lang=js"
export * from "./TrustCustomerNotFound.vue?vue&type=script&lang=js"
import style0 from "./TrustCustomerNotFound.vue?vue&type=style&index=0&id=2fabd9b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fabd9b0",
  null
  
)

export default component.exports